<mat-card class="actions-card">
    <loading [isLoading]="isLoading"></loading>
    <mat-card-title class="card-title">Acciones</mat-card-title>
    <mat-card-content>

        <!-- acciones de notificación -->
        <div class="actions-flex" *ngIf="alarmData.idAlarmCategory == 1">
            <mat-card class="action-card" (click)="DeactivateAlarm()">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/silence_alarm.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Silenciar Aviso</label>
                </mat-card-content>
            </mat-card>

            <mat-card class="action-card" (click)="UnassignFromGeofence()">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/remove_car.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Desasigar de Origen</label>
                </mat-card-content>
            </mat-card>
            
        </div>

        <!-- acciones de valet Parkking -->
        <div class="actions-flex" *ngIf="alarmData.idAlarmCategory == 2">
            <mat-card class="action-card" (click)="DeactivateAlarm()">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/silence_alarm.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Silenciar Aviso</label>
                </mat-card-content>
            </mat-card>

            <mat-card class="action-card" (click)="DeleteValetParking()">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/no_parking.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Desactivar Valet Parking</label>
                </mat-card-content>
            </mat-card>

            <mat-card class="action-card disabled">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/bandit.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Activar Modo Recuperación</label>
                </mat-card-content>
            </mat-card>
            
        </div>

        <!-- acciones de recuperacion -->
        <div class="actions-flex" *ngIf="alarmData.idAlarmCategory == 3">
            <mat-card class="action-card" (click)="DeactivateAlarm()">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/silence_alarm.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Silenciar Aviso</label>
                </mat-card-content>
            </mat-card>

            <mat-card class="action-card" (click)="BlockActive()" *ngIf="this.canBeLocked">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/blocked_car.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Bloquear Vehículo</label>
                </mat-card-content>
            </mat-card>

            <mat-card class="action-card" (click)="UnblockActive()" *ngIf="this.canBeLocked">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/unlock.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Desbloquear Vehículo</label>
                </mat-card-content>
            </mat-card>

            <mat-card class="action-card disabled">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/protected_lock.webp" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Desactivar Modo Recuperación</label>
                </mat-card-content>
            </mat-card>
            
        </div>

        <!-- acciones de seguridad -->
        <div class="actions-flex" *ngIf="alarmData.idAlarmCategory == 4">
            <mat-card class="action-card" (click)="DeactivateAlarm()">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/silence_alarm.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Silenciar Aviso</label>
                </mat-card-content>
            </mat-card>

            <mat-card class="action-card" (click)="UnassignFromGeofence()">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/remove_car.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Desasigar de Origen</label>
                </mat-card-content>
            </mat-card>

            <mat-card class="action-card" (click)="DeactivateGeofence()">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/location_off.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Apagar Origen</label>
                </mat-card-content>
            </mat-card>

            <mat-card class="action-card disabled">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/bandit.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Activar Modo Recuperación</label>
                </mat-card-content>
            </mat-card>
            
        </div>

        <!-- acciones de alarma general -->
        <div class="actions-flex" *ngIf="alarmData.idAlarmCategory == 0">
            <mat-card class="action-card" (click)="DeactivateAlarm()">
                <mat-card-title class="action-title"> 
                    <img src="../../../../../assets/img/silence_alarm.png" alt="">
                </mat-card-title>
                <mat-card-content class="action-content">
                    <label >Silenciar Aviso</label>
                </mat-card-content>
            </mat-card>
            
        </div>

    </mat-card-content>
</mat-card>